
export const jobDetailData = {
  id: 'job-001',
  badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
  position: '프리미엄 바텐더 급구',
  companyName: '라운지 퍼플',
  companyLogo: 'https://public.readdy.ai/ai/img_res/a04714b788bdc7f6c5d1be273e5db14f.jpg',
  companyIntro: '강남 최고급 프리미엄 라운지바. 세련된 인테리어와 최상의 서비스를 제공하는 업계 선두 매장입니다.',
  location: '서울 강남구 역삼동 123-45',
  experience: '경력무관',
  salary: '월 400~600만원',
  workType: '정규직',
  workHours: '20:00 ~ 04:00',
  deadline: '2025-08-15',
  views: 2847,
  applicants: 38,
  postedDate: '2025-06-28',
  description: '강남 최고급 프리미엄 라운지 퍼플에서 함께할 바텐더를 모집합니다. 저희 매장은 고급스러운 분위기와 최상의 서비스를 자랑하며, 업계 최고 수준의 대우를 보장합니다. 칵테일 제조 경험이 있으신 분은 우대하며, 성실하고 밝은 성격의 지원자를 환영합니다. 팀워크를 중시하는 환경에서 함께 성장할 수 있는 기회를 드립니다.',
  requirements: [
    '만 19세 이상 성인',
    '밝고 긍정적인 성격',
    '기본적인 서비스 마인드',
    '주말 근무 가능자',
    '칵테일 제조 경험 우대',
    '외국어 가능자 우대',
  ],
  benefits: [
    { icon: 'ri-money-dollar-circle-line', title: '업계 최고 대우', desc: '기본급 + 인센티브 + 팁' },
    { icon: 'ri-restaurant-line', title: '식사 제공', desc: '출근 시 매일 식사 제공' },
    { icon: 'ri-taxi-line', title: '교통비 지원', desc: '퇴근 시 택시비 전액 지원' },
    { icon: 'ri-calendar-check-line', title: '주휴수당', desc: '주 5일 근무 시 주휴수당 지급' },
    { icon: 'ri-shield-check-line', title: '4대 보험', desc: '정규직 전환 시 4대 보험 가입' },
    { icon: 'ri-graduation-cap-line', title: '교육 지원', desc: '바텐더 자격증 취득 지원' },
  ],
};

export const similarJobs = [
  {
    id: 'job-002',
    position: '홀 매니저',
    company: '클럽 네온',
    location: '역삼',
    salary: '월 350만원',
    image: 'https://readdy.ai/api/search-image?query=modern%20upscale%20bar%20interior%20with%20purple%20neon%20lighting%20elegant%20counter%20sophisticated%20nightlife%20atmosphere%20premium%20lounge%20design&width=400&height=240&seq=job-img-1&orientation=landscape',
  },
  {
    id: 'job-003',
    position: '서버 모집',
    company: '바 미드나잇',
    location: '신사',
    salary: '시급 2만원',
    image: 'https://readdy.ai/api/search-image?query=stylish%20cocktail%20bar%20setup%20with%20purple%20ambient%20lighting%20premium%20bottles%20display%20modern%20nightclub%20interior%20sophisticated%20venue%20design&width=400&height=240&seq=job-img-2&orientation=squarish',
  },
  {
    id: 'job-004',
    position: 'DJ 모집',
    company: '라운지 블랙',
    location: '청담',
    salary: '회당 30만원',
    image: 'https://readdy.ai/api/search-image?query=professional%20DJ%20booth%20setup%20with%20purple%20LED%20lights%20modern%20nightclub%20turntable%20equipment%20dark%20ambient%20atmosphere%20premium%20venue&width=400&height=240&seq=job-img-3&orientation=landscape',
  },
];
